import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.string.pad-start";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getQueryString } from '@/libs/url-token';
import { sm4 } from 'sm-crypto';
import MobileLogin from "./MobileLogin.vue";
var SM4_KEY = '1w2sdfr890s12s34';
var BJCA_LOCAL_TEST_KEY = 'BJCA_LOCAL_TEST';
function stringToHex(str) {
  var hex = '';
  for (var i = 0; i < str.length; i++) {
    hex += str.charCodeAt(i).toString(16).padStart(2, '0');
  }
  return hex;
}

/**
 * 登录弹窗组件
 * 支持三种登录方式：北京市教育统一认证、账号密码登录、智教中国通行证
 */
export default {
  components: {
    MobileLogin: MobileLogin
  },
  data: function data() {
    return {
      isMobile: typeof window !== 'undefined' && window.innerWidth < 800,
      mobileStep: 0,
      // 控制登录弹窗显示/隐藏
      adminDia: false,
      // 登录方式列表
      bntsList: [{
        id: '1',
        name: '北京市教育统一认证'
      },
      // 统一认证登录
      {
        id: '2',
        name: '账号密码登录'
      },
      // 本地账号登录
      {
        id: '3',
        name: '智教中国通行证'
      } // 智教中国登录
      ],
      // 用户登录表单数据
      userMsg: {
        username: "",
        // 用户名
        password: "",
        // 密码
        uuid: "",
        // 设备唯一标识
        verificationCode: "",
        // 验证码
        keyId: "" // 密钥ID
      },
      loading: false,
      isLocalBjcaTestEnabled: process.env.NODE_ENV === 'development',
      localTestLoading: false,
      localTestForm: {
        jyId: ''
      },
      isEnter: true,
      // 表单验证规则
      userRules: {
        username: [{
          required: true,
          message: "请输入账号",
          trigger: "blur"
        }, {
          min: 2,
          max: 18,
          message: "长度在 2 到 18 个字符",
          trigger: "blur"
        }, {
          required: true,
          pattern: /^[\u4e00-\u9fa5_a-zA-Z0-9.·-]+$/,
          message: "账号不支持特殊字符",
          trigger: "blur"
        }],
        password: [{
          required: true,
          message: "请输入密码",
          trigger: "blur"
        }
        // {
        //   min: 6,
        //   max: 16,
        //   message: "长度在 6 到 16 个字符",
        //   trigger: "blur"
        // }
        // {
        //   validator: passwordRule,
        //   trigger: "blur",
        // },
        ],
        verificationCode: [{
          required: true,
          message: "请输入验证码",
          trigger: "blur"
        }, {
          min: 4,
          max: 4,
          message: "长度在 4 个字符",
          trigger: "blur"
        }]
      },
      localTestRules: {
        jyId: [{
          required: true,
          message: "请输入教育ID",
          trigger: "blur"
        }]
      }
    };
  },
  // created() {
  //     if (this.isLocalBjcaTestEnabled) {
  //         this.bntsList.splice(1, 0, {
  //             id: '4',
  //             name: '北京市教育统一认证（本地测试）'
  //         });
  //     }
  // },
  methods: {
    /**
     * 选择登录方式
     * @param {Object} item - 登录方式对象
     * @param {string} item.id - 登录方式ID
     */
    tologin: function tologin(_ref) {
      var id = _ref.id;
      // 北京市教育统一认证 - 跳转到统一认证页面
      var targetUrl = 'https://am.bjedu.cn/am/oauth2/authorize?service=initService&response_type=code&client_id=8ad2f7b1fe0a444e&scope=uid+cn+userIdCode&redirect_uri=https://vocational.beijing.smartedu.cn/system/auth/bjca/login&decision=Allow';

      // 移动端：用 mobileStep 替代 carousel
      if (this.isMobile) {
        if (!id || id == 2) {
          this.mobileStep = 1;
          return;
        }
        if (id == 4) {
          this.mobileStep = 2;
          return;
        }
        if (id == 3) {
          targetUrl = 'https://am.bjedu.cn/am/zjNationEdu/authorize.do?clientId=8ad2f7b1fe0a444e';
        }
        window.open(targetUrl, '_self');
        return;
      }

      // PC端：原有 carousel 逻辑
      if (!id || id == 2) {
        var aindex = id ? 1 : 0;
        this.$refs.carousel.setActiveItem(aindex);
        return;
      }
      if (id == 4) {
        this.$refs.carousel.setActiveItem(2);
        return;
      }
      if (id == 3) {
        //国教的认证
        targetUrl = 'https://am.bjedu.cn/am/zjNationEdu/authorize.do?clientId=8ad2f7b1fe0a444e';
      }
      window.open(targetUrl, '_self');
    },
    mobileLogin: function mobileLogin() {
      var _this = this;
      this.$refs.mobileLoginForm.validate(function (valid) {
        if (!valid) return;
        _this.loading = true;
        var users = {
          username: _this.userMsg.username,
          password: sm4.encrypt(_this.userMsg.password, stringToHex(SM4_KEY))
        };
        _this.$store.dispatch("user/login", users).then(function () {
          _this.$store.dispatch("user/getInfo").then(function () {
            _this.loading = false;
            _this.adminDia = false;
            _this.mobileStep = 0;
            sessionStorage.setItem("isFlag", "true");
            _this.$message.success("操作成功。");
          });
        }).catch(function () {
          _this.loading = false;
          _this.$message.error("登录失败");
        });
      });
    },
    backToLoginOptions: function backToLoginOptions() {
      this.$refs.carousel.setActiveItem(0);
    },
    localTestLogin: function localTestLogin() {
      var _this2 = this;
      this.$refs.localTestForm.validate(function (valid) {
        if (!valid) {
          return;
        }
        _this2.localTestLoading = true;
        _this2.$store.dispatch("user/localBjcaLogin", _this2.localTestForm.jyId.trim()).then(function () {
          _this2.localTestLoading = false;
          _this2.adminDia = false;
          sessionStorage.setItem(BJCA_LOCAL_TEST_KEY, "true");
          sessionStorage.setItem("isFlag", "true");
          _this2.$message.success("本地测试登录成功");
        }).catch(function (error) {
          _this2.localTestLoading = false;
          _this2.$message.error(error && error.message || "本地测试登录失败");
        });
      });
    },
    /**
     * 账号密码登录
     * @param {string} v - 表单ref名称
     */
    login: function login(v) {
      var _this3 = this;
      this.$refs[v].validate(function (valid) {
        if (valid) {
          _this3.loading = true;
          var users = {
            username: _this3.userMsg.username,
            password: sm4.encrypt(_this3.userMsg.password, stringToHex(SM4_KEY))
            // realPassword: this.userMsg.password,
            // code: this.userMsg.verificationCode,
            // keyId: this.userMsg.keyId,
            // urlSign: this.prCode
          };
          _this3.$store.dispatch("user/login", users).then(function (res) {
            _this3.loading = false;
            // this.$router.push({
            // path: "/dashboard",
            // name: "Dashboard"
            // });

            _this3.$store.dispatch("user/getInfo").then(function (data) {
              _this3.adminDia = false;
              sessionStorage.setItem("isFlag", "true");
              _this3.$message.success("操作成功。");
            });
          }).catch(function () {
            _this3.loading = false;
            _this3.$message.error("登录失败");
          });
        } else {
          return false;
        }
      });
    }
  },
  /**
   * 组件挂载后执行
   * 处理URL中的access_token参数，用于统一认证回调登录
   */
  mounted: function mounted() {
    var _this4 = this;
    this._onResize = function () {
      _this4.isMobile = window.innerWidth < 800;
    };
    window.addEventListener('resize', this._onResize);
    this.$nextTick(function () {
      // 从URL获取access_token（统一认证回调携带）
      var access_token = getQueryString('access_token');
      if (access_token) {
        // 使用token进行自动登录
        _this4.loading = true;
        _this4.$store.dispatch("user/loginByToken", access_token).then(function (res) {
          sessionStorage.setItem("isFlag", "true");
          _this4.loading = false;
          var params = new URLSearchParams(window.location.search);
          params.delete('access_token');
          var query = params.toString();
          var cleanUrl = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
          window.history.replaceState({}, document.title, cleanUrl);
        }).catch(function (error) {
          _this4.loading = false;
          _this4.$message.error(error && error.message || "统一认证登录失败");
        });
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this._onResize);
  },
  watch: {
    adminDia: function adminDia(val) {
      if (val) this.mobileStep = 0;
    }
  }
};